<template>
  <div>
    <!-- 头部 -->
    <el-card class="header-card">
      <div class="login-header flex between items-center">
        <div class="flex">
          <div class="logo pointer flex items-center">
            <img src="../assets/images/logo.png" style="width: 100%" alt="" />
          </div>
          <h1>找回密码</h1>
        </div>
        <div class="back pointer flex items-center flex-center">
          <span class="pointer" @click="goLogin">登陆</span>
          <span class="ml-5 mr-5">|</span>
          <span @click="goIndex">返回首页</span>
        </div>
      </div>
    </el-card>

    <!-- 中间内容 -->
    <div class="content-box">
      <el-card class="login-box">
        <div class="top flex between items-center">
          <div class="flex items-center" :class="setup == 1 ? 'active' : ''">
            <div class="icon">1</div>
            <span class="text ml-10">验证身份</span>
          </div>
          <div class="xian"></div>
          <div class="flex items-center" :class="setup == 2 ? 'active' : ''">
            <div class="icon">2</div>
            <span class="text ml-10">设置新密码</span>
          </div>
          <div class="xian"></div>
          <div class="flex items-center" :class="setup == 3 ? 'active' : ''">
            <div class="icon">3</div>
            <span class="text ml-10">成功</span>
          </div>
        </div>

        <div class="bottom">
          <el-row>
            <el-col :span="19" :offset="5">
              <el-form
                :inline-message="true"
                :model="resetForm"
                :rules="resetFormRules"
                ref="resetFormRef"
              >
                <el-form-item prop="name" v-if="setup == 1">
                  <el-input
                    @blur="nameBlur"
                    v-model="resetForm.supplierName"
                    placeholder="请输入企业名称"
                    class="input-with-select"
                  >
                    <template slot="prepend">
                      <div>
                        <img src="../assets/images/qiye.png" alt="" />
                      </div>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item prop="phone" v-if="setup == 1">
                  <el-input
                    @blur="phoneBlur"
                    v-model="resetForm.phone"
                    placeholder="请输入手机号"
                    class="input-with-select"
                  >
                    <template slot="prepend">
                      <div>
                        <img src="../assets/images/phone.png" alt="" />
                      </div>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item :inline-message="true" v-if="setup == 1">
                  <div class="flex items-center">
                    <el-input
                      v-model="resetForm.verifyCode"
                      @blur="codeBlur"
                      style="width: 232px"
                      placeholder="请输入短信动态码"
                      class="input-with-select"
                    >
                      <template slot="prepend">
                        <div>
                          <img src="../assets/images/code.png" alt="" />
                        </div>
                      </template>
                    </el-input>
                    <div v-if="isCodeBtn" class="code pointer" @click="getCode">
                      发送验证码
                    </div>
                    <div v-else class="code pointer">{{ time }}后获取</div>
                    <span class="error" v-if="isCodeTrue">{{
                      codeErrMsg
                    }}</span>
                  </div>
                </el-form-item>

                <el-form-item
                  style="margin-top: 57px"
                  prop="password"
                  v-if="setup == 2"
                >
                  <el-input
                    @blur="newPwdBlur"
                    v-model="resetForm.password"
                    placeholder="请输入新密码"
                    class="input-with-select"
                    type="password"
                  >
                    <template slot="prepend">
                      <div>
                        <img src="../assets/images/pwd.png" alt="" />
                      </div>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item prop="checkPwd" v-if="setup == 2">
                  <el-input
                    @blur="checkPwdBlur"
                    v-model="resetForm.checkPwd"
                    placeholder="请再次输入密码"
                    class="input-with-select"
                    type="password"
                  >
                    <template slot="prepend">
                      <div>
                        <img src="../assets/images/pwd.png" alt="" />
                      </div>
                    </template>
                  </el-input>
                </el-form-item>

                <el-form-item>
                  <el-button
                    style="margin-top: 26px"
                    v-if="setup == 1"
                    @click="next"
                    :disabled="isLogin"
                    type="primary"
                    class="w100 next"
                    >下一步</el-button
                  >
                  <el-button
                    style="margin-top: 30px"
                    v-if="setup == 2"
                    @click="yes"
                    :disabled="isYes"
                    type="primary"
                    class="w100 next"
                    >确认</el-button
                  >
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>

          <div
            v-if="setup == 3"
            class="suc flex flex-column flex-center items-center"
          >
            <img src="../assets/images/suc.png" alt="" />
            <div class="title">修改成功</div>
            <div class="tips">您的密码已经修改生效，请重新登陆。</div>
          </div>
        </div>
      </el-card>
    </div>
    <Footer />
    <Result
      :title="resultTitle"
      :SubTitle="subTitle"
      :isShow="resultShow"
      @change="resultClose"
    />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Result from "../components/Result.vue";

export default {
  components: {
    Footer,
    Result,
  },
  data() {
    // 自定义校验密码规则
    var validatePass = (rule, value, callback) => {
      if (value === "" || value == null) {
        callback(new Error("请输入密码"));
      } else if (value.length < 8) {
        callback(new Error("长度不少于8位"));
      } else {
        if (this.resetForm.checkPwd !== "") {
          this.$refs.resetFormRef.validateField("checkPwd");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "" || value == null) {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.resetForm.password) {
        callback(new Error("两次密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      resultTitle: "",
      subTitle: "",
      resultShow: false,
      time: 59,
      timer: null,
      isCodeBtn: true,
      isLogin: true,
      isYes: true,
      setup: 1,
      isCodeTrue: false,
      resetForm: {
        supplierName: "",
        phone: "",
        verifyCode: "",
        token: "123456",
        password: null,
        checkPwd: null,
      },
      resetFormRules: {
        supplierName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        verifyCode: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        password: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
        checkPwd: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
      codeErrMsg: "请输入验证码",
      userId: null,
    };
  },
  methods: {
    resultClose() {
      this.resultShow = false;
    },
    //获取验证码
    async getCode() {
      if (!this.resetForm.phone) {
        this.resultTitle = "请输入手机号";
        this.subTitle1 = "";
        this.resultShow = true;
        return;
      }

      // 请求验证码
      const { data: res } = await this.$axios.get("/api/verifyCode/getCode", {
        params: {
          type: 3,
          phone: this.resetForm.phone,
        },
      });
      if (res.code == 200) {
        this.resultTitle = "发送成功";
        this.subTitle = res.msg;
        this.resultShow = true;
        this.isCodeBtn = false;
        this.timer = setInterval(() => {
          if (this.time > 1) {
            this.time--;
          } else {
            clearInterval(this.timer);
            this.time = 59;
            this.isCodeBtn = true;
          }
        }, 1000);
      } else {
        console.log(res);
      }
    },
    handleClick() {},
    //点击注册
    register() {
      this.$router.push("/register");
    },
    //登录
    goLogin() {
      this.$router.push("/login");
    },
    //回首页
    goIndex() {
      this.$router.push("/index");
    },
    //点击下一步
    next() {
      this.$refs.resetFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        const { data: res } = await this.$axios.get(
          "/api/userInfo/verifyUser",
          {
            params: this.resetForm,
          }
        );
        if (res.code == 200) {
          this.userId = res.data;
          this.setup = 2;
        } else {
          console.log(res);
        }
      });
    },
    //点击确定
    async yes() {
      if (this.resetForm.password == "" || this.resetForm.password == null) {
        this.resultTitle = "请输入密码";
        this.subTitle1 = "";
        this.resultShow = true;
        return;
      }
      if (this.resetForm.checkPwd == "" || this.resetForm.checkPwd == null) {
        this.resultTitle = "请再次输入密码";
        this.subTitle1 = "";
        this.resultShow = true;
        return;
      }
      if (this.resetForm.checkPwd !== this.resetForm.password) {
        this.resultTitle = "两次密码输入不一致";
        this.subTitle1 = "";
        this.resultShow = true;
        return;
      }
      const { data: res } = await this.$axios({
        url: "/api/userInfo/modifyUserPwd",
        method: "put",
        params: {
          userId: this.userId,
          newPwd: this.resetForm.password,
        },
        headers: {
          token: "",
        },
      });
      if (res.code == 200) {
        this.setup = 3;
        setTimeout(() => {
          this.$router.push("/login");
        }, 3000);
      } else {
        console.log(res);
      }
    },
    //验证码是去焦点
    codeBlur() {
      if (this.resetForm.code == "") {
        this.isCodeTrue = true;
        this.codeErrMsg = "请输入验证码";
      } else {
        this.isCodeTrue = false;
      }
      if (
        this.resetForm.code != "" &&
        this.resetForm.name != "" &&
        this.resetForm.phone != ""
      ) {
        this.isLogin = false;
      }
    },
    //企业名称是去焦点
    nameBlur() {
      if (
        this.resetForm.code != "" &&
        this.resetForm.name != "" &&
        this.resetForm.phone != ""
      ) {
        this.isLogin = false;
      }
    },
    //手机号是去焦点
    phoneBlur() {
      if (
        this.resetForm.code != "" &&
        this.resetForm.name != "" &&
        this.resetForm.phone != ""
      ) {
        this.isLogin = false;
      }
    },
    //输入新密码是去焦点
    newPwdBlur() {
      if (this.resetForm.password != "" && this.resetForm.checkPwd != "") {
        this.isYes = false;
      }
    },
    //再次输入密码失去焦点
    checkPwdBlur() {
      if (this.resetForm.password != "" && this.resetForm.checkPwd != "") {
        this.isYes = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-card {
  border: none !important;
}
/deep/.el-card__body {
  padding: 0 !important;
}
/deep/.header-card.el-card.is-always-shadow {
  box-shadow: 0px 3px 6px rgb(204 217 233 / 70%);
}
// 头部
.header-card {
  position: relative;
  z-index: 100;
}
.login-header {
  width: 1200px;
  height: 84px;
  margin: 0 auto;
  .logo {
    width: 330px;
    // background-color: #1c65c4;
    height: 84px;
    color: #fff;
    text-align: center;
    line-height: 84px;
  }
  h1 {
    line-height: 84px;
    font-size: 36px;
    margin-left: 50px;
  }
  .back {
    width: 176px;
    box-sizing: border-box;
    height: 40px;
    border-radius: 20px;
    border: 1px solid #1c65c4;
    color: #1c65c4;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
  }
}
// 内容
.content-box {
  height: 640px;
  background: url("../assets/images/ditu.png") no-repeat;
  position: relative;
  .login-box {
    width: 700px;
    height: 415px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    padding-left: 78px;
    padding-right: 78px;
    padding-top: 50px;

    .top {
      .icon {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background-color: #ccd9e9;
        font-size: 16px;
        color: #fff;
        line-height: 35px;
        text-align: center;
      }
      .text {
        font-size: 18px;
        color: #95b3db;
      }
      .xian {
        width: 84px;
        height: 1px;
        background-color: #95b3db;
      }
      .active {
        .icon {
          background-color: #00ffcc;
        }
        .text {
          color: #3b426b;
        }
      }
    }

    .bottom {
      margin-top: 25px;
      .suc {
        .title {
          font-size: 18px;
          color: #3b426b;
          margin-top: 15px;
        }
        .tips {
          font-size: 14px;
          color: #ccd9e9;
          margin-top: 3px;
        }
      }
    }

    .set-pwd {
      color: #95b3db;
    }
    .register {
      color: #3b426b;
    }
    .text {
      color: #ccd9e9;
      line-height: 14px;
    }
    .text1 {
      color: #3b426b;
      line-height: 14px;
    }
    .code {
      font-size: 14px;
      color: #3b426b;
      margin-left: 16px;
    }
    .error {
      color: #ff0053;
      font-size: 12px;
      margin-left: 10px;
    }
    .next {
      width: 320px;
    }
    /deep/.el-form-item__error--inline {
      color: #ff0053;
      font-size: 12px;
    }
    /deep/.el-input-group {
      width: 320px;
    }
  }
  /deep/.login-box.el-card.is-always-shadow {
    box-shadow: 0px 0px 15px rgba(28, 101, 196, 0.3);
  }
  /deep/.el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
    background-color: #e4e7ed;
    z-index: 1;
  }
  /deep/.el-tabs__active-bar {
    width: 16px !important;
    // transform: translateX(100%) !important;
    margin-left: 30px;
    background-color: #1c65c4;
  }
  /deep/.el-tabs__item.is-active {
    color: #02224b;
  }
  /deep/.el-tabs__item {
    color: #ccd9e9;
    font-size: 18px;
  }
  /deep/.el-input-group__prepend {
    background-color: #ccd9e9;
    padding: 0 12px;
  }
  /deep/.el-input__inner {
    background-color: #f7f9fc;
    border: none;
    font-size: 14px;
    // color: #ccd9e9;
  }
  /deep/.pwd-register.el-form-item {
    margin-bottom: 0px;
  }
  /deep/.el-button--primary.is-disabled {
    background-color: #1c65c4;
    opacity: 0.5;
  }
  /deep/.el-button--primary {
    background-color: #1c65c4;
  }
}
</style>